export const CHANNEL_CONTACT = 'Contact';
export const CHANNEL_HIRING = 'Hiring';
export const CHANNEL_SUBSCRIBE = 'Subscribe';
export const CHANNEL_BOOKING = 'Booking';

export const CHANNELS = [CHANNEL_HIRING, CHANNEL_BOOKING, CHANNEL_SUBSCRIBE, CHANNEL_CONTACT];
